import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Constants } from "../../data/constants";
import { FormControl, Validators } from "@angular/forms";
import {
  invokeUploadFileWithProgress,
  setFileName,
} from "src/app/store/file/file.actions";
import { HttpEvent, HttpEventType, HttpResponse } from "@angular/common/http";
import { Observable, takeUntil } from "rxjs";
import { AppStateInterface } from "src/app/store/appState.interface";
import { select, Store } from "@ngrx/store";
import { uploadFileProgressSelector } from "src/app/store/file/file.selectors";
import { BaseComponent } from "src/app/base.component";
import { AdDetailsInterface } from "../../models/advertising-campaigns/ad-details.interface";
import { addCampaignSelector } from "src/app/store/advertisingCampaign/advertiserCampaign.selectors";
import { invokeAdDetails } from "src/app/store/advertisingCampaign/advertisingCampaign.actions";
import { SuccessDto } from "../../models/success-dto";
import { NgbProgressbarConfig } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-video-guidelines-and-upload",
  templateUrl: "./video-guidelines-and-upload.component.html",
  styleUrls: ["./video-guidelines-and-upload.component.scss"],
})
export class VideoGuidelinesAndUploadComponent
  extends BaseComponent
  implements OnInit
{
  @Output() emitFileName = new EventEmitter<string | null>();
  @Input() note: string;
  videoGuideLink = Constants.VIDEO_GUIDE_LINK;

  showProgress: boolean = false;
  uploadProgress: number = 0;
  videoLinkFormControl: FormControl<any> = new FormControl(null, [
    Validators.required,
    Validators.minLength(3),
    Validators.pattern("^https://.*"),
  ]);

  showError: boolean = false;
  isShown: boolean = false;
  companyName: string;
  uploadFileProgress$: Observable<HttpEvent<any> | null | HttpResponse<any>>;
  filename: string | null;

  files: File[] = [];
  formData = new FormData();
  videoLink: string;

  uploadFile$: Observable<HttpEvent<any> | null | HttpResponse<any>>;

  ad: AdDetailsInterface;
  adDetails$: Observable<AdDetailsInterface>;
  created$: Observable<SuccessDto | null>;

  @Input() isShowGuide: boolean = true
  constructor(
    private store: Store<AppStateInterface>,
    configPB: NgbProgressbarConfig
  ) {
    super(store);
    configPB.max = 100;
    configPB.striped = true;
    configPB.animated = true;
    configPB.type = "primary";
    configPB.height = "20px";
    this.uploadFile$ = this.store
      .pipe(select(uploadFileProgressSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.created$ = this.store
      .pipe(select(addCampaignSelector))
      .pipe(takeUntil(this.ngDestroyed$));
  }

  ngOnInit(): void {
    this.created$.subscribe((created: SuccessDto | null) => {
      if (created != null) {
        this.filename = null;
        this.files = [];
      }
    });

    this.uploadFile$.subscribe(
      (result: HttpEvent<any> | null | HttpResponse<{ filename: string }>) => {
        if (result?.type == HttpEventType.UploadProgress) {
          this.showProgress = true;
          const total = result?.total ?? 1;
          this.uploadProgress = Math.round((result.loaded / total) * 100);
        }
        if (result?.type == HttpEventType.Response) {
          this.filename =
            (result as HttpResponse<{ filename: string }>)?.body?.filename ??
            "";
          this.emitFileName.emit(this.filename);
          this.store.dispatch(setFileName({ filename: null }));
          setTimeout(() => {
            this.showProgress = false;
          }, 2000);
        }
      }
    );
  }

  onSelect(event: File[]) {
    this.showProgress = true;
    if (event[0].size > 5242880) {
      this.showError = true;
      this.showProgress = false;
    } else {
      this.files.push(event[0]);
      this.store.dispatch(
        invokeAdDetails({
          invokeAdDetails: { ...this.ad, videoFile: event[0] },
        })
      );
      this.isShown = true;
      const formData = new FormData();
      formData.append("file", this.files[0], this.files[0].name);
      this.store.dispatch(invokeUploadFileWithProgress({ file: formData }));
    }
  }

  onRemove(_t36: File) {
    this.filename = null;
    this.emitFileName.emit(this.filename);
    this.files = [];
    this.uploadProgress = 0;
    this.showProgress = false;
    this.store.dispatch(
      invokeAdDetails({ invokeAdDetails: { ...this.ad, videoFile: null } })
    );
  }
}
